import { render, staticRenderFns } from "./simulacao_tabs.vue?vue&type=template&id=43384b97"
import script from "./simulacao_tabs.vue?vue&type=script&lang=js"
export * from "./simulacao_tabs.vue?vue&type=script&lang=js"
import style0 from "./simulacao_tabs.vue?vue&type=style&index=0&id=43384b97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VRow,VTab,VTabs})
